import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {LogType, UserSource} from "@/store/player/types";
import DropDownList from "phaser3-rex-plugins/templates/ui/dropdownlist/DropDownList";
import SpriteUtils from "@/utils/sprite-utils";
import {SimpleDropDownList} from "@/scenes.ui/simple-drop-down-list";
import {VerticalLongPanel} from "@/scenes.ui/vertical-long-panel";
import CU from "@/utils/c-u";

export class ArenaSettings extends VerticalLongPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, rewardHour:number, changeHourCallback: (newRewardHour: number) => unknown) {
        super(scene, canvas, Tr('arena.sett'));

        // this.getWindow().setScale(1 * CU.S, 1.3* CU.S)
        // this.getWindow().y+=60 * CU.S;
        // this.y -= 20 * CU.S;

        let introText = TextUtils.addTextByFamily(scene, Tr('choose.arena.time') + ":", 0, -200,
            '#ffd465', 17, 'normal', 400, Fonts.MYRIADPRO_REGULAR);
        let infoText = TextUtils.addTextByFamily(scene, Tr('arena.reward.time.info'), 0, -70,
            '#cbc6c6', 15, 'normal', 300, Fonts.MYRIADPRO_REGULAR);

        infoText.alpha = 0.7
        this.add([introText, infoText]);

        this.addCloseButton(Tr('acpt'), () => {
            if(dropDown.getValue()){
                changeHourCallback(Number(dropDown.getValue().split(':')[0]))
            }
        });

        let times = [];

        let currentUTCOffset = new Date().getTimezoneOffset()/60;
        let mskUTCOffset = -3;

        for (let i = 0;  i < 6; i++) { //TODO перенести варианты выбора времени на сервер
            let offset =  Math.round(mskUTCOffset-currentUTCOffset);
            let hour = i*4 + offset;
            if(hour < 0) hour += 24;
            if(hour > 24) hour -= 24;

            times.push( (hour< 10? '0' : '') + hour + ':00');
        }
        let dropDown = new SimpleDropDownList(scene, canvas, 0,  -130*CU.S, times.sort(), true, rewardHour, () => {
            this.okButton.visible = false;
            infoText.visible = false;
        }, () => {
            this.okButton.visible = true;
            infoText.visible = true;
        } );
        this.add(dropDown);
        // dropDown.setScale(1, 1/1.05)
    }

    getCloseButtonY(): number {
        return 40;
    }

}
